import { getFieldErrors, isApiError, readApiError } from '@/services/api';

const FALLBACK_MESSAGE = 'The cancellation could not be saved. Please try again.';

export function cancellationErrorMessage(error: unknown): string {
    if (!isApiError(error) || !error.data) return FALLBACK_MESSAGE;
    const firstFieldMessage = Object.values(getFieldErrors(error))[0]?.[0];
    return firstFieldMessage ?? readApiError(error.data).message;
}
